module.exports = __webpack_public_path__ + "static/img/text3.4fc6e95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/text3.png
// module id = ddqn
// module chunks = 1